const defaultState = {
    organizationHasChanged: false,
    organizationId: '',
    organizationName: '',
    test: false,
};

export const organizationInfo = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        default:
            return state;
    }
};
